import { IndividualPlaceInput } from '../../lib/types/models/trip-booking/trip-date'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function retain({ id, input }: IdInput<{ input: IndividualPlaceInput[] }>) {
  return restApiClient
    .url(constructApiUrl(API.tripDates.retain.url, { id }))
    .post<never, IndividualPlaceInput[]>(input)
}
